import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useStudentsService } from '../../../../apis/students/useStudentsService';
import { TPaginationParams } from '../../../../apis/__shared/shared.interfaces';
import { TAttendanceByDateResponse } from '../../../../apis/__shared/attendance.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getStudentAttendanceByDateKey = 'get-student-attendance-by-date';

export const useStudentAttendanceHook = (
  params: TPaginationParams,
  classId?: string,
  sectionId?: string,
  fromDate?: Date,
  toDate?: Date,
  options?: Omit<
    UseQueryOptions<TAttendanceByDateResponse, TQueryError>,
    'queryKey' | 'queryFn'
  >
): UseQueryResult<TAttendanceByDateResponse, TQueryError> => {
  const { getStudentAttendanceByDate } = useStudentsService();

  const queryKey = [
    getStudentAttendanceByDateKey,
    params,
    classId,
    sectionId,
    fromDate,
    toDate,
  ];

  const { enabled: enabledOption, ...restOptions } = options ?? {};

  return useQuery<TAttendanceByDateResponse, TQueryError>({
    queryKey,
    queryFn: () =>
      getStudentAttendanceByDate(params, classId, sectionId, fromDate, toDate),
    ...restOptions,
    enabled:
      !!classId &&
      classId !== 'select' &&
      (enabledOption !== undefined ? enabledOption : true),
  });
};
